module.exports = __webpack_public_path__ + "static/fonts/fontello.a1386b4.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/fonts/fontello.eot?26533562
// module id = 540
// module chunks = 1